import { put } from "redux-saga/effects";
import { setServerError } from "../all.slice";

function* setServerErrorDefault() {
    yield put(setServerError({ error: null, status: null, message: null }));
}

export default setServerErrorDefault;